import axios from '../axios';
import {isRetinaScreen, validateResponse, getResponseError} from "./utility";
import {colors} from "./colors";

export default class Vehicle {

    static getStatus = (vehicle) => {
        return vehicle.status
    }

    static save = async (data) => {
        console.log(data)
        let res
        if (!data.sellerId) {
            throw new Error('SellerId required!')
        }
        const headers = {
            'Content-Type': 'application/json',
        }
        if (data.oldVin && data.oldVin !== data.vin) {
            data.id = null
        }
        if (data.id) {
            res = await axios.put(`/vehicles/${data.id}`, data, {
                headers: headers,

            })
        } else {
            res = await axios.post(`/vehicles`, data, {
                headers: headers,
            })
        }

        if (!validateResponse(res)) {
            throw new Error(getResponseError(res))
        }
        return res.data
    }


    static getMatchingClients = async (xchangeId) => {
        let res

        const headers = {
            'Content-Type': 'application/json',
        }

        res = await axios.get(`/vehicles/matching-clients/${xchangeId}`, {
            headers: headers,
        })

        if (!validateResponse(res)) {
            throw new Error(getResponseError(res))
        }
        return res.data
    }

    // not used
    // static findOrCreate = async (data) => {
    //     console.log(data)
    //     let res
    //     if (!data.sellerId) {
    //         throw new Error('SellerId required!')
    //     }
    //     const headers = {
    //         'Content-Type': 'application/json',
    //     }
    //     if (data.oldVin && data.oldVin !== data.vin) {
    //         data.id = null
    //     }

    //     res = await axios.post(`/frontapp/xchange/find`, data, {
    //         headers: headers,
    //         cancelToken: axios.cancelToken.token
    //     })

    //     if (!validateResponse(res)) {
    //         throw new Error('Request failed')
    //     }
    //     return res.data
    // }

    static getColorsFromState = (state, interiorColor, exteriorColor) => {
        console.log(state, interiorColor, exteriorColor)
        const result = {}
        if (state.exteriorColors.length) {
            result.exteriorColor = state.exteriorColors.find((item) => item.name === exteriorColor)
        } else {
            const color = colors.find((item) => item.name === exteriorColor)
            result.exteriorColor = {name: color.name, swatch_list: [color.code]}
        }
        if (state.interiorColors.length) {
            result.interiorColor = state.interiorColors.find((item) => item.name === interiorColor)
        } else {
            const color = colors.find((item) => item.name === interiorColor)
            result.interiorColor = {name: color.name, swatch_list: [color.code]}
        }
        console.log(result)

        return result
    }
}

export const MatchingClientStatuses = {
    NoVin: 'noVin',
    NotQualifiedAndUnknown: 'notQualifiedAndUnknown',
    NotQualified: 'notQualified',
    NotInBoostXchange: 'notInBoostXchange', // not
    Lost: 'lost',           // not
    Disqualified: 'disqualified',
    NotInterested: 'notInterested',
    Open: 'open',
    OfferMade: 'offerMade',
    OfferPresented: 'offerPresented',
    OfferAccepted: 'offerAccepted',
    Approved: 'approved',
    AppointmentScheduled: 'appointmentScheduled',
    VehicleAcquired: 'vehicleAcquired',
    Archived: 'archived' // not
}

const MatchingClientStatuses2Title = {
    [MatchingClientStatuses.OfferMade]: 'Offer Made',
    [MatchingClientStatuses.OfferAccepted]: 'Offer Accepted',
    [MatchingClientStatuses.AppointmentScheduled]: 'Appointment Scheduled',
    [MatchingClientStatuses.VehicleAcquired]: 'Vehicle Acquired'
}

export const getTrimData = (trimData, vehicleTrims) => {

    console.log(trimData)
    console.log(trimData.mileage_list)
    const result = {}

    console.log(result)

    result.uvc = trimData.uvc
    result.make = trimData.make
    result.model = trimData.model
    result.model_year = trimData.model_year
    result.style = trimData.style
    result.series = trimData.series
    result.transmission = trimData.transmission
    result.drivetrain = trimData.drivetrain
    result.trim = [trimData.series, trimData.style].join(' ')

    const trims = []
    vehicleTrims.forEach((item) => {
        trims.push({
            uvc: item.uvc,
            series: item.series,
            style: item.style,
        })
    })
    result.trims = trims

    return result
}

export const getTitleStatus = (value) => {
    if (['Lien', 'Missing'].includes(value)) {
        return 'Unknown'
    }

    if (['Salvage/Rebuilt', 'Rebuilt/Salvage'].includes(value)) {
        return 'Salvage/Rebuilt'
    }

    if (['Clean', 'Parts Only', 'Unknown'].includes(value)) {
        return value
    }

    return 'Unknown'
}

export const getTitle = (vehicle) => {
    return vehicle ? [vehicle.model_year, vehicle.make, vehicle.model].join(' ').trim() : '';
}

export const VehicleImageTypes = {
    ExteriorFront: 1,
    ExteriorRightSide: 2,
    ExteriorLeftSide: 3,
    ExteriorRear: 4,
    InteriorFrontSeats: 5,
    InteriorRearSeats: 6,
    InteriorDash: 7,
    InteriorHeadliner: 8,
    AdditionalPhoto: 9
};

export const VehicleImageTypeLabels = {
    [VehicleImageTypes.ExteriorFront]: 'Exterior Front',
    [VehicleImageTypes.ExteriorRightSide]: 'Exterior Right Side',
    [VehicleImageTypes.ExteriorLeftSide]: 'Exterior Left Side',
    [VehicleImageTypes.ExteriorRear]: 'Exterior Rear',
    [VehicleImageTypes.InteriorFrontSeats]: 'Interior Front Seats',
    [VehicleImageTypes.InteriorRearSeats]: 'Interior Rear Seats',
    [VehicleImageTypes.InteriorDash]: 'Interior Dash',
    [VehicleImageTypes.InteriorHeadliner]: 'Interior Headliner',
    [VehicleImageTypes.AdditionalPhoto]: 'Additional Photo'
}

const _getVehicleImages = (car, source) => {
    let images;
    if (typeof source !== 'undefined') {
        images = car && car.images ? car.images[source] : [];
    } else {
        images = car && car.images ? ( Array.isArray(car.images.s3) && car.images.s3.length > 0 ? car.images.s3 : car.images.original) : [];
    }
    Array.isArray(images) || (images = []);
    return images;
}

export const getVehicleImages = (car, source) => {
    const images =  _getVehicleImages(car, source).map(item => {
        const row = {
            original: null,
            thumbnail: null,
            type: null
        };
        // 100 150 200 320 480 640 720 800
        if (typeof item === 'object') {
            row.original = item.original;
            row.type = item.type;
            const minSize = isRetinaScreen() ? 600 : 200;
            const availableSizes = Object.keys(item).sort((size, size2) => size > size2 ? -1 : 1);
            let thumbSize = availableSizes.find(size => size <= minSize);
            if (!thumbSize) {
                const availableLargeSizes = Object.keys(item)
                    .filter(size => size >= minSize)
                    .sort((size, size2) => size >= size2 ? 1 : -1);
                thumbSize = availableLargeSizes.length > 0 ? availableLargeSizes[0] : null;
            }
            row.thumbnail = thumbSize ? item[thumbSize] : row.original;
        } else {
            row.original = item;
            row.thumbnail = item;
        }

        return row;
    });
    
    return images;
}

export const getVehicleImageByType = (vehicle, type) => {
    const images = getVehicleImages(vehicle);
    return images.find(image => +image.type === +type);   
}

export const pushVehicleImageByLink = (vehicle, link, type) => {
    vehicle || (vehicle = {});
    const images = getVehicleImages(vehicle, 's3');
    
    const image = {
        original: link,
        type
    };
    const imgIdx = images.findIndex(item => +item.type === +type);
    if (imgIdx > -1 && images[imgIdx].original !== link ) {
        images[imgIdx] = image;
    } else if (imgIdx === -1) {
        images.push(image);
    }
    console.log('images', images);
    vehicle.images || (vehicle.images = {});
    vehicle.images.s3 = images;
}

export const findThumbnailByOriginal = (url, images) => {
    Array.isArray(images) || (images = []);
    const row = images.find(image => image && image.original === url);

    return row ? row.thumbnail : null;
}

export const getNoImage = () => {
    return '/img/no-image.png';
}

export const getOptionCount = (vehicle) => {
    const options = vehicle &&  typeof vehicle.options === 'object' ? vehicle.options : {};
        return Object.values(options).filter(option => option.value === true).length;
}

const getMatchingClientStatus = (vehicle) => {
    return vehicle && vehicle.matchingClient && 
        vehicle.matchingClient.status;
}

export const getMatchingClientStatusTitle  = (vehicle) => {
    const status = getMatchingClientStatus(vehicle);

    return MatchingClientStatuses2Title[status];
}

export const canUserChangeAppointment = (vehicle, appointment) => {
    const can = getMatchingClientStatus(vehicle) !== MatchingClientStatuses.VehicleAcquired;
        
    return can;
}